// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"98927677","205":"1037ad07","330":"c57fba41","496":"1fb35f5b","568":"a7168a9e","612":"9cd68c9c","696":"0592b86b"}[chunkId] + ".chunk.js";
};